import React, { Component } from "react";
import Footer2 from "../../../../components/webfooter2/webFooter2";

import "./market.less";

import imgBan from "../../../../assets/img/solution/banner5.png";
import nextImg from "../../../../assets/img/solution/next.png";

import i1 from "../../../../assets/img/solution/12.png";
import i2 from "../../../../assets/img/solution/20.png";
import i3 from "../../../../assets/img/solution/13.png";
import i4 from "../../../../assets/img/solution/18.png";
import i5 from "../../../../assets/img/solution/14.png";
import i6 from "../../../../assets/img/solution/15.png";

import i21 from "../../../../assets/img/solution/1.png";
import i22 from "../../../../assets/img/solution/35.png";
import i23 from "../../../../assets/img/solution/41.png";

import bg1 from "../../../../assets/img/solution/bg4.png";
import bg2 from "../../../../assets/img/solution/bg5.png";
import bg3 from "../../../../assets/img/solution/bg6.png";





export default class Home5 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			footer:{
				title: "我想要咨询此行业",
				phone:'400-9958-578'
			},
			active:[true,false,false,false]
			
		};
	}
	
	clickActive=(key)=>{
		let list  = this.state.active
		for(let i in list){
			if(i==key){
				list[i] = true
			}else{
				list[i] = false
			}
		}
		this.setState({active:[...list]})
		let str = 'active'+key
		this.scrollToAnchor(str)
	}
	//锚点滚动
	scrollToAnchor = (anchorName) => {
		if (anchorName) {
			// 找到锚点
			let anchorElement = document.getElementById(anchorName);
			// 如果对应id的锚点存在，就跳转到锚点
			if(anchorElement) { anchorElement.scrollIntoView({block: 'start', behavior: 'smooth'}); }
		}
	}


	render() {
		const bgImg1 = {
			backgroundRepeat: "no-repeat",
			backgroundImage: "url(" + bg1 + ")", //图片的路径
		};
		const bgImg2 = {
			backgroundRepeat: "no-repeat",
			backgroundImage: "url(" + bg2 + ")", //图片的路径
		};
		const bgImg3 = {
			backgroundRepeat: "no-repeat",
			backgroundImage: "url(" + bg3 + ")", //图片的路径
		};
		

		return (
			<div className="solution-content solution-content-5">

				<section className="solution-1">
					<img alt="" src={imgBan} />
				</section>

				<section className="solution-2">
					<ul>
						<li className={this.state.active[0]?'active':''} onClick={this.clickActive.bind(this,0)}>行业趋势</li>
						<li className={this.state.active[1]?'active':''} onClick={this.clickActive.bind(this,1)}>行业痛点</li>
						<li className={this.state.active[2]?'active':''} onClick={this.clickActive.bind(this,2)}>解决方案</li>
						<li className={this.state.active[3]?'active':''} onClick={this.clickActive.bind(this,3)}>方案优势</li>
					</ul>
				</section>

				<section className="solution-3" id="active0">
					<h3>行业趋势</h3>
					<ul>
						<li style={bgImg1}>
							<span>整体解决方案</span>
							<span>为企业提供一套整合商超发票管理解决方案及服务</span>
						</li>
						<li  style={bgImg2}>
							<span>提升用户体验</span>
							<span>为更好触达消费者，让消费者有更好的获票体验</span>
						</li>
						<li  style={bgImg3}>
							<span>数字化管理</span>
							<span>互联网+带动商超行业发票管理和升级</span>
						</li>
						
					</ul>
				</section>
				<section className="solution-4" id="active1">
					<h3>行业痛点</h3>
					<ul>
						<li>
							<span>成本高</span>
							<span>纸质发票使用量大，发票领用、存放、打印成本高</span>
						</li>
						<li>
							<span>服务质量</span>
							<span>节假日索要发票客户多、长时间排队等候，降低了客户服务质量</span>
						</li>
						<li>
							<span>人工成本高</span>
							<span>需设置专门的开票柜台增加专门的开票人员，人员成本高</span>
						</li>
					</ul>
				</section>

				<section className="solution-5" id="active2">
					<h3>解决方案</h3>
					<div>顾客消费后商家打印开票二维码,消费者扫码进行开票,通过短信、邮箱等接收发票</div>
					<ul>
						<div className="ul_div">
							<li>
								<img alt="" src={i1} />
								<span>打印小票和二维码</span>
								<img alt="" src={nextImg}/>
							</li>
							<li>
								<img alt="" src={i2} />
								<span>销售系统</span>
								<img alt="" src={nextImg}/>
							</li>
						</div>
						<div className="ul_div">
							<li>
								<img alt="" src={i3} />
								<span>扫描二维码</span>
								<img alt="" src={nextImg}/>
							</li>
							<li>
								<img alt="" src={i4} />
								<span>接口服务</span>
								<img alt="" src={nextImg}/>
							</li>
						</div>
						<li>
							<img alt="" src={i5} />
							<span>中税开票系统</span>
							<img alt="" src={nextImg}/>
						</li>
						<li>
							<img alt="" src={i6} />
							<span>发送发票</span>
						</li>
					</ul>
				</section>


				<section className="solution-6" id="active3">
					<h3>方案优势</h3>
					<ul>
						<li>
							<div>
								<span>节约成本</span>
								<img alt="" src={i21} />
							</div>
							<p>电子化领取方式无需纸质载体及打印，降低硬件成本</p>
						</li>
						<li>
							<div>
								<span>便于保存</span>
								<img alt="" src={i22} />
							</div>
							<p>随时随地打印发票，解决纸票不易于保存缺陷</p>
						</li>
						<li>
							<div>
								<span>客户满意高</span>
								<img alt="" src={i23} />
							</div>
							<p>省去等待开票环节，提高用户体验和用户粘度</p>
						</li>
						
					</ul>
				</section>
				
				

				<Footer2 title={this.state.footer} />
			</div>
		);
	}
}
